"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _constellation = require("@zillow/constellation");
var S = _interopRequireWildcard(require("./styles"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var OutputCard = function OutputCard(_ref) {
  var title = _ref.title,
    tooltipText = _ref.tooltipText,
    value = _ref.value;
  var tooltip = /*#__PURE__*/(0, _jsxRuntime.jsx)(_constellation.Tooltip, {
    body: /*#__PURE__*/(0, _jsxRuntime.jsx)(_constellation.Paragraph, {
      children: tooltipText
    })
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(S.OutputCardContainer, {
    padding: "xs",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_constellation.Text, {
      fontType: "bodySmall",
      as: "h4",
      children: [title, ' ', /*#__PURE__*/(0, _jsxRuntime.jsx)(_constellation.TooltipPopper, {
        triggered: tooltip
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_constellation.Paragraph, {
      fontType: "h4",
      as: "strong",
      children: value
    })]
  });
};
var _default = exports["default"] = OutputCard;